<template>
  <b-dropdown
      variant="link"
      toggle-class="text-decoration-none p-0"
      no-caret
      dropright
      boundary="scrollParent"
  >
    <template #button-content>
      <i class="fas fa-ellipsis-h"></i>
    </template>

    <b-dropdown-item
        v-for="(action, index) in actions"
        :key="index"
        :disabled="action.disabled && action.disabled(item)"
        @click="handleActionClick(action, $event)"
        v-b-tooltip.hover="action.disabled && action.disabled(item) ? action.disabledMessage(item) : ''"
    >
      <div class="withdrawal-analysis__dropdown-item" :class="{ 'text-muted': action.disabled && action.disabled(item) }">
        <div>
          <span>{{ action.label }}</span>
        </div>
        <div>
          <i :class="action.icon"></i>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "DropdownActions",
  props: {
    actions: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true
    },
  },
  methods: {
    handleActionClick(action, event) {
      event.preventDefault();
      this.$emit('action', {
        type: action.action,
        item: this.item
      });
    }
  }
};
</script>